// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class Minute extends Component {

  static defaultProps = {
    isSelected: false
  };

  static propTypes = {
    value: PropTypes.number.isRequired,

    onChange: PropTypes.func.isRequired,

    isSelected: PropTypes.bool
  };

  onChange = () => {
    this.props.onChange(this.props.value);
  };

  render() {
    const className = classNames('col-xs-4', 'hour_chooser__minute', {
      selected: this.props.isSelected
    });

    return (
      <div
        className={className}
        onClick={this.onChange}
      >
        {this.props.value}
      </div>
    );
  }

}

export default Minute;
